<div class="msa-scl">
  @for (item of items(); track item.label) {
    <lib-stat-card [color]="item.color">
      <span stat-icon>{{ item.icon }}</span>
      <span stat-value>{{ item.value }}</span>
      <span stat-label>{{ item.label }}</span>
      @if (item.trend) {
        <span
          stat-trend
          [style.color]="item.trendDirection === 'down' ? 'var(--msa-sc-trend-down)' : 'var(--msa-sc-trend-up)'"
        >{{ item.trend }}</span>
      }
    </lib-stat-card>
  }
</div>
